 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER1101COMEOUTOFSECLUSION from '@/components/0_chapter1101comeoutofseclusion'
 import A_CHAPTER1102THEBANDITWITHTHEQIOFEXPECTATION from '@/components/1_chapter1102thebanditwiththeqiofexpectation'
 import A_CHAPTER1103BENEFICENTBANDIT from '@/components/2_chapter1103beneficentbandit'
 import A_CHAPTER1104LIGHTNINGTONOURISHTHESOUL from '@/components/3_chapter1104lightningtonourishthesoul'
 import A_CHAPTER1105INEXPLICABLEINVITATION from '@/components/4_chapter1105inexplicableinvitation'
 import A_CHAPTER1106MADMAGICALBEAST from '@/components/5_chapter1106madmagicalbeast'
 import A_CHAPTER1107MYSTERIOUSABODE from '@/components/6_chapter1107mysteriousabode'
 import A_CHAPTER1108INTELLIGENTDEPARTEDSOUL from '@/components/7_chapter1108intelligentdepartedsoul'
 import A_CHAPTER1109DEATHCREPTCLOSER from '@/components/8_chapter1109deathcreptcloser'
 import A_CHAPTER1110ASURAMANSION from '@/components/9_chapter1110asuramansion'
 import A0_CHAPTER1111ESCAPEASURAMANSION from '@/components/10_chapter1111escapeasuramansion'
 import A1_CHAPTER1112ABNORMALMAGICALBEAST from '@/components/11_chapter1112abnormalmagicalbeast'
 import A2_CHAPTER1113POISONOUSGRASS from '@/components/12_chapter1113poisonousgrass'
 import A3_CHAPTER1114BREAKTHROUGHFOURSEASREALM from '@/components/13_chapter1114breakthroughfourseasrealm'
 import A4_CHAPTER1115THERISEOFTHEZHONGSHANIMMORTALSECT from '@/components/14_chapter1115theriseofthezhongshanimmortalsect'
 import A5_CHAPTER1116FOUNDINGSECT from '@/components/15_chapter1116foundingsect'
 import A6_CHAPTER1117DISTURBANCE from '@/components/16_chapter1117disturbance'
 import A7_CHAPTER1118YUZHOUACCIDENT from '@/components/17_chapter1118yuzhouaccident'
 import A8_CHAPTER1119BEFORETHEGREATWAR from '@/components/18_chapter1119beforethegreatwar'
 import A9_CHAPTER1120CHANGTIANSPIRITUALARRAY from '@/components/19_chapter1120changtianspiritualarray'
 import A0_CHAPTER1121REVISITINGTHEPOISONOUSGROUNDSOFTHEYUZHOU from '@/components/20_chapter1121revisitingthepoisonousgroundsoftheyuzhou'
 import A1_CHAPTER1122HALFCORPSE from '@/components/21_chapter1122halfcorpse'
 import A2_CHAPTER1123MONITORBY from '@/components/22_chapter1123monitorby'
 import A3_CHAPTER1124CLAIRVOYANCE from '@/components/23_chapter1124clairvoyance'
 import A4_CHAPTER1125CHESSPIECE from '@/components/24_chapter1125chesspiece'
 import A5_CHAPTER1126CROSSINGOFHALFCORPSE from '@/components/25_chapter1126crossingofhalfcorpse'
 import A6_CHAPTER1127HALFCORPSESFOOTSTEPS from '@/components/26_chapter1127halfcorpsesfootsteps'
 import A7_CHAPTER1128ANEXPECTEDASSASSINATION from '@/components/27_chapter1128anexpectedassassination'
 import A8_CHAPTER1129THEREALHALFIMMORTALAPPARATUS from '@/components/28_chapter1129therealhalfimmortalapparatus'
 import A9_CHAPTER1130WARSOUNDS from '@/components/29_chapter1130warsounds'
 import A0_CHAPTER1131VENOMOUSCADAVERBATTLE from '@/components/30_chapter1131venomouscadaverbattle'
 import A1_CHAPTER1132CHANGEOFVENOMOUSCADAVER from '@/components/31_chapter1132changeofvenomouscadaver'
 import A2_CHAPTER1133SUSPENDEDWAR from '@/components/32_chapter1133suspendedwar'
 import A3_CHAPTER1134REINFORCEMENTS from '@/components/33_chapter1134reinforcements'
 import A4_CHAPTER1135THREEHALFIMMORTALAPPARATUSS from '@/components/34_chapter1135threehalfimmortalapparatuss'
 import A5_CHAPTER1136RESOLVEONE from '@/components/35_chapter1136resolveone'
 import A6_CHAPTER1137LASTVENOMOUSCADAVER from '@/components/36_chapter1137lastvenomouscadaver'
 import A7_CHAPTER1138POISONOUSCORPSEKING from '@/components/37_chapter1138poisonouscorpseking'
 import A8_CHAPTER1139PSEUDODEATHMETHOD from '@/components/38_chapter1139pseudodeathmethod'
 import A9_CHAPTER1140REGRESSION from '@/components/39_chapter1140regression'
 import A0_CHAPTER1141REWARDDESIRED from '@/components/40_chapter1141rewarddesired'
 import A1_CHAPTER1142CRAZYCULTIVATIONSPEED from '@/components/41_chapter1142crazycultivationspeed'
 import A2_CHAPTER1143CHASEDOWNTOHERE from '@/components/42_chapter1143chasedowntohere'
 import A3_CHAPTER1144JIANLINSATTACK from '@/components/43_chapter1144jianlinsattack'
 import A4_CHAPTER1145JIANLINHADFALLEN from '@/components/44_chapter1145jianlinhadfallen'
 import A5_CHAPTER1146RETURNOFTHEHERO from '@/components/45_chapter1146returnofthehero'
 import A6_CHAPTER1147THEDISCUSSIONBETWEENTHEDISCIPLEANDTHESECTLEADER from '@/components/46_chapter1147thediscussionbetweenthediscipleandthesectleader'
 import A7_CHAPTER1148EXPELSECT from '@/components/47_chapter1148expelsect'
 import A8_CHAPTER1149DIWUJIATTACKED from '@/components/48_chapter1149diwujiattacked'
 import A9_CHAPTER1150DIWUJISDESTINY from '@/components/49_chapter1150diwujisdestiny'
 import A0_CHAPTER1151THEMANAGEROFQINGZHOU from '@/components/50_chapter1151themanagerofqingzhou'
 import A1_CHAPTER1152THEPRICEOFINHERITANCE from '@/components/51_chapter1152thepriceofinheritance'
 import A2_CHAPTER1153DRACONICVEINOFJIUZHOU from '@/components/52_chapter1153draconicveinofjiuzhou'
 import A3_CHAPTER1154STRUGGLEFORTHEDRAGONVEIN from '@/components/53_chapter1154struggleforthedragonvein'
 import A4_CHAPTER1155CONTROLLINGTHEDRACONICPULSE from '@/components/54_chapter1155controllingthedraconicpulse'
 import A5_CHAPTER1156COLLABORATIONFROMMANAGERS from '@/components/55_chapter1156collaborationfrommanagers'
 import A6_CHAPTER1157IMMERSEONESELFINTRAINING from '@/components/56_chapter1157immerseoneselfintraining'
 import A7_CHAPTER1158DIVINESPEEDOFCULTIVATION from '@/components/57_chapter1158divinespeedofcultivation'
 import A8_CHAPTER1159OUYANGSDEATH from '@/components/58_chapter1159ouyangsdeath'
 import A9_CHAPTER1160WAR from '@/components/59_chapter1160war'
 import A0_CHAPTER1161THEBATTLEFIELDABOVETHEPEAK from '@/components/60_chapter1161thebattlefieldabovethepeak'
 import A1_CHAPTER1162DIWUJISHERITAGE from '@/components/61_chapter1162diwujisheritage'
 import A2_CHAPTER1163DEATHBREAKTHROUGH from '@/components/62_chapter1163deathbreakthrough'
 import A3_CHAPTER1164THEWEIYUNSECTAFTERTHECALAMITY from '@/components/63_chapter1164theweiyunsectafterthecalamity'
 import A4_CHAPTER1165GUZHENGSROPINGIN from '@/components/64_chapter1165guzhengsropingin'
 import A5_CHAPTER1166NEWGREATELDEROFTHESECT from '@/components/65_chapter1166newgreatelderofthesect'
 import A6_CHAPTER1167LEAVINGQINGZHOU from '@/components/66_chapter1167leavingqingzhou'
 import A7_CHAPTER1168POISONMASTERCHURCHHEADQUARTERS from '@/components/67_chapter1168poisonmasterchurchheadquarters'
 import A8_CHAPTER1169YUZHOUDRAGONPULSEMANAGER from '@/components/68_chapter1169yuzhoudragonpulsemanager'
 import A9_CHAPTER1170MOBILIZINGTHEPOWEROFTHEDRAGONFOUNTAIN from '@/components/69_chapter1170mobilizingthepowerofthedragonfountain'
 import A0_CHAPTER1171OUYANGSGRANDSON from '@/components/70_chapter1171ouyangsgrandson'
 import A1_CHAPTER1172CHUYUNXUEWASTAKENAWAY from '@/components/71_chapter1172chuyunxuewastakenaway'
 import A2_CHAPTER1173CHUTIANSFURY from '@/components/72_chapter1173chutiansfury'
 import A3_CHAPTER1174KILLINGFORENTRY from '@/components/73_chapter1174killingforentry'
 import A4_CHAPTER1175PILLREFININGCITY from '@/components/74_chapter1175pillrefiningcity'
 import A5_CHAPTER1176THEARROGANTAPOTHECARYGUILDHQ from '@/components/75_chapter1176thearrogantapothecaryguildhq'
 import A6_CHAPTER1177GOVERNTHEHAUGHTY from '@/components/76_chapter1177governthehaughty'
 import A7_CHAPTER1178THEHIDDENRULESOFTHEPILLREFININGCITY from '@/components/77_chapter1178thehiddenrulesofthepillrefiningcity'
 import A8_CHAPTER1179STOVEHEARTHALL from '@/components/78_chapter1179stovehearthall'
 import A9_CHAPTER1180UPPERGRADEOFGOLDMEDALLIONASSESSMENT from '@/components/79_chapter1180uppergradeofgoldmedallionassessment'
 import A0_CHAPTER1181ARROGANT from '@/components/80_chapter1181arrogant'
 import A1_CHAPTER1182EARTHGRADENINEPILLS from '@/components/81_chapter1182earthgradeninepills'
 import A2_CHAPTER1183YOUNGUPPERGRADEOFGOLDMEDALLION from '@/components/82_chapter1183younguppergradeofgoldmedallion'
 import A3_CHAPTER1184NIUGURANGAVESOMEADVICESANDSUGGESTIONS from '@/components/83_chapter1184niugurangavesomeadvicesandsuggestions'
 import A4_CHAPTER1185FIRSTDELEGATION from '@/components/84_chapter1185firstdelegation'
 import A5_CHAPTER1186SNEAKIN from '@/components/85_chapter1186sneakin'
 import A6_CHAPTER1187UNDERGROUNDMEDICINALMATERIALSMARKET from '@/components/86_chapter1187undergroundmedicinalmaterialsmarket'
 import A7_CHAPTER1188ARANK1HEAVENGRADEPILLENTRUSTMENT from '@/components/87_chapter1188arank1heavengradepillentrustment'
 import A8_CHAPTER1189DANCHENG from '@/components/88_chapter1189dancheng'
 import A9_CHAPTER1190THECOMMONELDERFLOWERHERBINHISHANDS from '@/components/89_chapter1190thecommonelderflowerherbinhishands'
 import A0_CHAPTER1191THEPROUDBLACKSMITHOFTHECAULDRON from '@/components/90_chapter1191theproudblacksmithofthecauldron'
 import A1_CHAPTER1192INVITATIONFROMSHININGHEARTPAVILION from '@/components/91_chapter1192invitationfromshiningheartpavilion'
 import A2_CHAPTER1193MASTEROFTHESHININGHEARTPAVILION from '@/components/92_chapter1193masteroftheshiningheartpavilion'
 import A3_CHAPTER1194JOINSHININGHEARTPAVILION from '@/components/93_chapter1194joinshiningheartpavilion'
 import A4_CHAPTER1195VERBALINHERITANCE from '@/components/94_chapter1195verbalinheritance'
 import A5_CHAPTER1196APOTHECARYYUMINGINHISHANDS from '@/components/95_chapter1196apothecaryyuminginhishands'
 import A6_CHAPTER1197THENOISEOFTHEINN from '@/components/96_chapter1197thenoiseoftheinn'
 import A7_CHAPTER1198MANSION from '@/components/97_chapter1198mansion'
 import A8_CHAPTER1199MYSTERIOUSDELEGATION from '@/components/98_chapter1199mysteriousdelegation'
 import A9_CHAPTER12001200REFININGPOISON from '@/components/99_chapter12001200refiningpoison'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter1101comeoutofseclusion",
 			"name" : "0_chapter1101comeoutofseclusion",
 			"component" : A_CHAPTER1101COMEOUTOFSECLUSION
 		},
 		{
 			"path" : "/1_chapter1102thebanditwiththeqiofexpectation",
 			"name" : "1_chapter1102thebanditwiththeqiofexpectation",
 			"component" : A_CHAPTER1102THEBANDITWITHTHEQIOFEXPECTATION
 		},
 		{
 			"path" : "/2_chapter1103beneficentbandit",
 			"name" : "2_chapter1103beneficentbandit",
 			"component" : A_CHAPTER1103BENEFICENTBANDIT
 		},
 		{
 			"path" : "/3_chapter1104lightningtonourishthesoul",
 			"name" : "3_chapter1104lightningtonourishthesoul",
 			"component" : A_CHAPTER1104LIGHTNINGTONOURISHTHESOUL
 		},
 		{
 			"path" : "/4_chapter1105inexplicableinvitation",
 			"name" : "4_chapter1105inexplicableinvitation",
 			"component" : A_CHAPTER1105INEXPLICABLEINVITATION
 		},
 		{
 			"path" : "/5_chapter1106madmagicalbeast",
 			"name" : "5_chapter1106madmagicalbeast",
 			"component" : A_CHAPTER1106MADMAGICALBEAST
 		},
 		{
 			"path" : "/6_chapter1107mysteriousabode",
 			"name" : "6_chapter1107mysteriousabode",
 			"component" : A_CHAPTER1107MYSTERIOUSABODE
 		},
 		{
 			"path" : "/7_chapter1108intelligentdepartedsoul",
 			"name" : "7_chapter1108intelligentdepartedsoul",
 			"component" : A_CHAPTER1108INTELLIGENTDEPARTEDSOUL
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js